import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class EllipseEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITELLIPSE;
}